import React from "react";

import {
  addGanttModelsToProject,
  deleteGanttModelsToProject,
  getGanttModelsByProjectId,
  updateGanttModel,
} from "@synthesis/shared-services/project-gge/projectGanttController/client";
import { logger } from "@synthesis/shared-utils";

export const useModelGantt = (projectId: string) => {
  const [ganttModels, setGanttModels] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (!projectId) {
      return;
    }

    void (async () => {
      try {
        const { data: models } = await getGanttModelsByProjectId({ path: { projectId } });
        setGanttModels(models.map((model) => model.modelId));
      } catch (error) {
        logger.error("useModelGantt/getGanttModelsByProjectId", error);
      }
    })();
  }, [projectId]);

  const addModelToGantt = (modelId: string) => {
    const newGanttModels = [...ganttModels, modelId];
    void addGanttModelsToProject({ body: { projectId, ids: [modelId] } });
    setGanttModels(newGanttModels);
  };

  const deleteModelFromGantt = (modelId: string) => {
    const newGanttModels = ganttModels.filter((_modelId) => _modelId !== modelId);
    void deleteGanttModelsToProject({ body: { projectId, ids: [modelId] } });
    setGanttModels(newGanttModels);
  };

  const patchModelIdFromGantt = async (modelId: string, newModelId: string) => {
    try {
      const newGanttModels = [...ganttModels];
      const index = ganttModels.indexOf(modelId);
      if (index >= 0) {
        newGanttModels[index] = newModelId;
      }

      await updateGanttModel({ path: { modelId }, query: { projectId, newModelId } });
      setGanttModels(newGanttModels);
    } catch (error) {
      logger.error("useModelGantt/updateGanttModel", error);
    }
  };

  return {
    addModelToGantt,
    deleteModelFromGantt,
    patchModelIdFromGantt,
    ganttModels,
  };
};
